import { DtoBase } from "../DtoBase";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { GroupDto } from "./GroupDto";
import { GroupTreeDto } from "./GroupTreeDto";

export class GetAllGroupsResultDto extends DtoBase {

	public GroupTree: GroupTreeDto;

	constructor() {
		super();

		this.GroupTree = new GroupTreeDto();
	}

	public get HasGroupTree(): boolean {
		return (!!this.GroupTree && this.GroupTree.Groups.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_all_groups_result = {};
		obj = obj.get_all_groups_result;

		super.Write(obj, context);

		if (this.HasGroupTree) {
			obj.group_tree = [];
			ObjSerUtils.WriteObjSerCollection(obj.group_tree, this.GroupTree.Groups, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_all_groups_result)
			throw new Error();
		obj = obj.get_all_groups_result;

		super.Read(obj, context);

		if (obj.group_tree !== undefined) {
			this.GroupTree = new GroupTreeDto();
			this.GroupTree.Read(obj, context);
		}
	}

}
